(function () {
  'use strict';

  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  var panelEl = document.getElementById('dn-map-picker');
  if (!panelEl) return;

  var subheadingEl = panelEl.querySelector('[data-dn-map-picker-address]');
  var appleLinkEl = panelEl.querySelector('[data-dn-map-picker-apple]');
  var googleAppLinkEl = panelEl.querySelector('[data-dn-map-picker-google-app]');

  function appleMapsUrl(address, name) {
    var apple = 'https://maps.apple.com/?address=' + encodeURIComponent(address);
    if (name) {
      apple += '&q=' + encodeURIComponent(name);
    }
    return apple;
  }

  function openPicker(address, name, googleUrl) {
    subheadingEl.textContent = name ? name + ' — ' + address : address;
    appleLinkEl.href = appleMapsUrl(address, name);
    googleAppLinkEl.href = googleUrl;

    panelEl.classList.add('dn-map-picker--open');
    document.body.classList.add('dn-map-picker-open');
  }

  function closePicker() {
    panelEl.classList.remove('dn-map-picker--open');
    document.body.classList.remove('dn-map-picker-open');
  }

  panelEl.querySelectorAll('[data-dn-map-picker-close]').forEach(function (el) {
    el.addEventListener('click', closePicker);
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-map-link]');
    if (!trigger) return;

    var address = trigger.getAttribute('data-map-link');
    if (!address) return;
    var name = trigger.getAttribute('data-map-name') || '';
    var googleUrl = trigger.href || ('https://www.google.com/maps?q=' + encodeURIComponent(address));

    e.preventDefault();

    if (!isTouchDevice) {
      window.open(googleUrl, '_blank', 'noopener');
      return;
    }

    openPicker(address, name, googleUrl);
  });
})();
